import React, {Component} from 'react';
import {Button, Col, Container, Input, Label, Progress, Row} from 'reactstrap';
import Axios from 'axios'
import {request} from "../../../helper/APIUtils";
import SweetAlert from 'react-bootstrap-sweetalert';
import HsmCertificateInput from "../../../common/hsm/HsmCertificateInput"
import HsmErrorAlert from '../../../common/hsm/HsmErrorAlert'
import * as LocalDateTime from "moment";
import moment from "moment";
import {EntegratorConf, VirtualHost} from "../../../constants";
import NormalButton from "../../../components/NormalButton";
import {EntegratorIdentifiers, serviceTypeEnum} from "../../../helper/enums";

class SingleFileSigner extends Component {

    constructor() {
        super();
        this.state = {
            pin: "",
            message: {
                text: "",
                color: "info"
            },
            percentage: 0,
            isVknTcknChange:false,
            useTimeStamp: false
        }
        this.signWithChange = this.signWithChange.bind(this);
        this.signWithoutChange = this.signWithoutChange.bind(this);
        this.signClicked = this.signClicked.bind(this);
        this.deferredSign = this.deferredSign.bind(this);
        this.deferredCounterSign = this.deferredCounterSign.bind(this);
        this.deferredPdfSign = this.deferredPdfSign.bind(this);
        this.hsmSign = this.hsmSign.bind(this);
        this.deferredSignComplete = this.deferredSignComplete.bind(this);
        this.deferredPdfSignComplete = this.deferredPdfSignComplete.bind(this);
        this.getIsVknTcknChangeForPrefix = this.getIsVknTcknChangeForPrefix.bind(this);
        this.signWithTimeStamp = this.signWithTimeStamp.bind(this);
        this.showTimeStampCheckBox = this.showTimeStampCheckBox.bind(this);

        this.axios = Axios.create({
            baseURL: "http://127.0.0.1:9999"
        });
    }

    componentDidMount() {
        this.getIsVknTcknChangeForPrefix();
        this.setState({
                useTimeStamp: (
                    (this.props.services && this.props.services.length === 1 && this.props.services.includes(serviceTypeEnum.E_ARSIV_BES_BIN_OTUZ_BIN))
                    || (this.props.currentUser && [3, 4].includes(this.props.currentUser.customerType))
                    || (this.props.services && this.props.services.length === 1 && this.props.services.includes(serviceTypeEnum.E_DEFTER) && this.showTimeStampCheckBox())
                    ||
                    (
                        this.showTimeStampCheckBox() &&
                        this.props.services && this.props.services.length === 2 &&
                        (this.props.services.includes(serviceTypeEnum.E_DEFTER)
                            &&
                            (this.props.services.includes(serviceTypeEnum.E_DEFTER_YUKLEME)) || (this.props.services.includes(serviceTypeEnum.E_DEFTER_IKINCIL_KOPYA))
                        )
                    )
                    ||
                    (
                        this.showTimeStampCheckBox() &&
                        this.props.services && this.props.services.length === 3 &&
                        this.props.services.includes(serviceTypeEnum.E_DEFTER) &&
                        this.props.services.includes(serviceTypeEnum.E_DEFTER_YUKLEME) &&
                        this.props.services.includes(serviceTypeEnum.E_DEFTER_IKINCIL_KOPYA)
                    )
                    ||  (this.showTimeStampCheckBox() &&
                        this.props.services && this.props.services.includes(serviceTypeEnum.E_TICARET))
                )
            }
        )
    }

    getIsVknTcknChangeForPrefix() {
        let prefix = VirtualHost.conf.resourcePrefix;
        let self = this;
        let params = {
            url: "/signature/helper/isVknTcknChangeForPrefix",
            method: "post",
            data: prefix
        };
        request(params)
            .then(response => {
                if (response && response.data)
                    self.setState({isVknTcknChange: true});
            }).catch(function (ex) {
            console.log(ex);
        });
    }

    signClicked() {
        if (moment(this.state.selectedCertificate.certificate.expiresOn).diff(LocalDateTime.now(), "hour") < 1) {
            this.setState({
                loading: false,
                alert: (
                    <SweetAlert danger
                                confirmBtnText="Tamam"
                                confirmBtnBsStyle="danger"
                                title="UYARI"
                                onConfirm={() => this.setState({alert: null})}>
                        Akıllı kartınızın geçerlilik süresi dolmuştur.
                    </SweetAlert>
                )
            });
        } else {
            if (this.props.currentUser.vknTckn !== null &&
                this.state.selectedCertificate.certificate.serial !== null &&
                this.props.currentUser.vknTckn !== this.state.selectedCertificate.certificate.serial) {
                if (this.state.isVknTcknChange) {
                    this.setState({
                        loading: false,
                        alert: (
                            <SweetAlert showCancel warning
                                        confirmBtnText="Değiştir"
                                        cancelBtnText="Yoksay"
                                        confirmBtnBsStyle="danger"
                                        cancelBtnBsStyle="default"
                                        title="UYARI"
                                        onConfirm={() => this.signWithChange()}
                                        onCancel={() => this.signWithoutChange()}>
                                Akıllı kart VKN/TCKN bilgisi ile kullanıcı VKN/TCKN bilgisi uyuşmuyor. Kullanıcı
                                bilgileri
                                Akıllı Kart bilgileri olarak değiştirilsin mi?
                            </SweetAlert>
                        )
                    });
                } else {
                    this.setState({
                        loading: false,
                        alert: (
                            <SweetAlert warning
                                        confirmBtnText="Kapat"
                                        confirmBtnBsStyle="danger"
                                        title="UYARI"
                                        onConfirm={() => this.setState({alert: null})}
                            >
                                Akıllı kart VKN/TCKN bilgisi ile kullanıcı VKN/TCKN bilgisi uyuşmuyor.
                                Akıllı kartınızı kontrol ediniz.
                            </SweetAlert>
                        )
                    });
                }
            } else
                this.signWithoutChange();
        }
    }

    signWithChange() {
        let self = this;
        self.setState({alert: null});
        let formData = new FormData();
        formData.append("userVkntckn", self.props.currentUser.vknTckn);
        formData.append("userName", self.props.currentUser.username);
        formData.append("cardVkntckn", self.state.selectedCertificate.certificate.serial);
        formData.append("cardName", self.state.selectedCertificate.certificate.commonName);
        let params = {
            url: "/customer/changeVkntckn",
            method: "post",
            data: formData
        };
        request(params)
            .then(response => {
                self.setState({
                    loading: false,
                    alert: (
                        <SweetAlert warning
                                    confirmBtnText="Tamam"
                                    confirmBtnBsStyle="danger"
                                    title="UYARI"
                                    onConfirm={() => this.props.onLogout()}>
                            Kullanıcı bilgileriniz güncellenmiştir. İmzalama işlemi için tekrar login olmanız gerekmektedir.
                        </SweetAlert>
                    )
                });
            }).catch(error => {
            self.setState({
                loading: false,
                alert: (
                    <SweetAlert danger
                                confirmBtnText="Tamam"
                                confirmBtnBsStyle="danger"
                                title="UYARI"
                                onConfirm={() => self.setState({alert: null})}>
                        Bir hata oluştu, lütfen daha sonra tekrar deneyiniz.
                    </SweetAlert>
                )
            });
        });
    }

    signWithTimeStamp(){
        this.setState({alert: null});
        Promise.resolve([])
            .then(param => {
                this.setState({
                    loading: true,
                    message: {
                        text: "Dosya imzalama için hazırlanıyor.",
                        color: "info"
                    },
                    percentage: 20
                });
                return param;
            })
            .then((param) => {
                return Promise.resolve(param)
                    .then(this.props.timeStampContract)
                    .catch(error => {
                        this.setState({ loading: false});
                        throw <SweetAlert error
                                          confirmBtnText="Tamam"
                                          confirmBtnBsStyle="error"
                                          title="Hata"
                                          onConfirm={() => this.setState({alert: null})}
                        >
                            {error.response.data && error.response.data.Error ? error.response.data.Error : "Zaman Damgasıyla imzalarken hata oluştu."}
                        </SweetAlert>
                    });
            })
            .then(param => {
                this.setState({
                    loading: false,
                    message: {
                        text: "İmzalama başarıyla tamamlandı.",
                        color: "info"
                    },
                    percentage: 100,
                    alert: (
                        <SweetAlert success
                                    confirmBtnText="Tamam"
                                    confirmBtnBsStyle="success"
                                    title="Başarılı"
                                    onConfirm={() => {
                                        this.setState({ alert: null});
                                        this.props.onComplete && this.props.onComplete();
                                    }
                                    }
                        >
                            İmzalama başarıyla tamamlandı.
                        </SweetAlert>
                    )
                });
                return param;
            })
            .catch(error => {
                this.setState({
                    loading: false,
                    alert: error
                });
                return error;
            });
    }

    signWithoutChange() {
        this.setState({alert: null});
        Promise.resolve([])
            .then(param => {
                this.setState({
                    loading: true,
                    message: {
                        text: "Dosya imzalama için hazırlanıyor.",
                        color: "info"
                    },
                    percentage: 20
                });
                return param;
            })
            .then(this.props.pdf ? this.deferredPdfSign : !this.props.counterSign ? this.deferredSign : this.deferredCounterSign)
            .then(param => {
                this.setState({
                    loading: true,
                    message: {
                        text: "Dosya imzalanıyor",
                        color: "info"
                    },
                    percentage: 40
                });
                return param;
            })
            .then(this.hsmSign)
            .then(param => {
                this.setState({
                    loading: true,
                    message: {
                        text: "Dosya imzalama tamamlanıyor.",
                        color: "info"
                    },
                    percentage: 60
                });
                return param;
            })
            .then(this.props.pdf ? this.deferredPdfSignComplete : this.deferredSignComplete)
            .then(param => {
                this.setState({
                    loading: true,
                    message: {
                        text: "İmzalı dosya gönderiliyor.",
                        color: "info"
                    },
                    percentage: 80
                });
                return param;
            })
            .then((param) => {
                param.certificate = this.state.selectedCertificate;
                return Promise.resolve(param)
                    .then(this.props.signCompleted)
                    .catch(error => {
                        throw <SweetAlert error
                                          confirmBtnText="Tamam"
                                          confirmBtnBsStyle="error"
                                          title="Hata"
                                          onConfirm={() => this.setState({alert: null})}
                        >
                            {error.response.data && error.response.data.Error ? error.response.data.Error : "İmzalı dosya gönderilirken hata oluştu."}
                        </SweetAlert>
                    });
            })
            .then(param => {
                this.setState({
                    loading: false,
                    message: {
                        text: "İmzalama başarıyla tamamlandı.",
                        color: "info"
                    },
                    percentage: 100,
                    alert: (
                        <SweetAlert success
                                    confirmBtnText="Tamam"
                                    confirmBtnBsStyle="success"
                                    title="Başarılı"
                                    onConfirm={() => {
                                        this.setState({alert: null});
                                        this.props.onComplete && this.props.onComplete();
                                    }
                                    }
                        >
                            İmzalama başarıyla tamamlandı.
                        </SweetAlert>
                    )
                });
                return param;
            })
            .catch(error => {
                this.setState({
                    loading: false,
                    alert: error
                });
                return error;
            });
    }

    deferredSign() {
        let params = {
            url: '/signature/helper/deferredSign',
            method: "post",
            data: {
                certificate: this.state.selectedCertificate.certificate.value,
                document: this.props.document,
                tagNamespaceURI: this.props.tagNamespaceURI,
                tagLocalName: this.props.tagLocalName,
                omitXmlDeclaration: this.props.omitXmlDeclaration
            }
        };

        return request(params)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                throw <SweetAlert error
                                  confirmBtnText="Tamam"
                                  confirmBtnBsStyle="error"
                                  title="Hata"
                                  onConfirm={() => this.setState({alert: null})}
                >
                    Dosya imzalama için hazırlanırken hata oluştu.
                </SweetAlert>
            });
    }

    showTimeStampCheckBox() {
        return EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
            EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
            EntegratorIdentifiers.MBT === EntegratorConf.identifier ||
            EntegratorIdentifiers.DEVATEK === EntegratorConf.identifier ;
    }

    deferredCounterSign() {
        let params = {
            url: '/signature/helper/deferredCounterSign',
            method: "post",
            data: {
                certificate: this.state.selectedCertificate.certificate.value,
                document: this.props.document,
                omitXmlDeclaration: this.props.omitXmlDeclaration
            }
        };

        return request(params)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                throw <SweetAlert error
                                  confirmBtnText="Tamam"
                                  confirmBtnBsStyle="error"
                                  title="Hata"
                                  onConfirm={() => this.setState({alert: null})}
                >
                    Dosya imzalama için hazırlanırken hata oluştu.
                </SweetAlert>
            });
    }

    deferredPdfSign() {
        let params = {
            url: '/signature/helper/deferredPdfSign',
            method: "post",
            data: {
                certificate: this.state.selectedCertificate.certificate.value,
                document: this.props.document,
            }
        };

        return request(params)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                throw <SweetAlert error
                                  confirmBtnText="Tamam"
                                  confirmBtnBsStyle="error"
                                  title="Hata"
                                  onConfirm={() => this.setState({alert: null})}
                >
                    Dosya imzalama için hazırlanırken hata oluştu.
                </SweetAlert>
            });
    }

    hsmSign(param) {
        return this.axios.post("/signature/signedinfo?hsmtype=" + this.state.selectedCertificate.hsmType, {
            base64: true,
            pin: this.state.pin,
            signedInfo: param.signedInfo,
            certificate: {
                keyId: this.state.selectedCertificate.certificate.keyId
            }
        })
            .then(response => {
                return {
                    signedDocument: param.signedDocument,
                    signature: response.data.signedDocument
                }
            })
            .catch(error => {
                throw <HsmErrorAlert error={error} onConfirm={() => this.setState({alert: null})}/>
            });
    }

    deferredSignComplete(param) {
        let params = {
            url: '/signature/helper/deferredSignComplete',
            method: "post",
            data: {
                signedDocument: param.signedDocument,
                signature: param.signature
            }
        };

        return request(params)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                throw <SweetAlert error
                                  confirmBtnText="Tamam"
                                  confirmBtnBsStyle="error"
                                  title="Hata"
                                  onConfirm={() => this.setState({alert: null})}
                >
                    Dosya imzalama tamamlanırken hata oluştu.
                </SweetAlert>
            });
    }

    deferredPdfSignComplete(param) {
        let params = {
            url: '/signature/helper/deferredPdfSignComplete',
            method: "post",
            data: {
                signedDocument: param.signedDocument,
                signature: param.signature
            }
        };

        return request(params)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                throw <SweetAlert error
                                  confirmBtnText="Tamam"
                                  confirmBtnBsStyle="error"
                                  title="Hata"
                                  onConfirm={() => this.setState({alert: null})}
                >
                    Dosya imzalama tamamlanırken hata oluştu.
                </SweetAlert>
            });
    }

    renderPin() {
        return <Container>
            <Row>
                <Label sm={12} md={3} disabled={true}>Pin</Label>
                <Col sm={12} md={5}>
                    <Input type="password" autoComplete="off" disabled={this.state.loading} value={this.state.pin}
                           onChange={e => {
                               this.setState({pin: e.target.value})
                           }}/>
                </Col>
                <Col sm={12} md={4}>
                    <Button className="TekBtn signature" style={{width: "100%"}} onClick={this.signClicked}
                            disabled={this.state.loading || !this.state.pin}>İmzala</Button>
                </Col>
            </Row>
        </Container>
    }

    onChangeCheck(){
        let useTimeStamp=this.state.useTimeStamp;
        this.setState({useTimeStamp:!useTimeStamp});
    }

    render() {

        return <Container>
            {this.state.alert}
            {
                (
                    this.props.type === "distributor" ||
                    (
                        this.props.services &&
                        this.props.services.length === 1 &&
                        (
                            this.props.services.includes(serviceTypeEnum.E_ARSIV_BES_BIN_OTUZ_BIN)
                            || this.props.services.includes(serviceTypeEnum.E_DEFTER_YUKLEME)
                            || this.props.services.includes(serviceTypeEnum.E_DEFTER_IKINCIL_KOPYA)
                            || (this.showTimeStampCheckBox() && this.props.services.includes(serviceTypeEnum.E_DEFTER))
                        )
                    ) ||
                    (
                        this.props.currentUser && [3, 4].includes(this.props.currentUser.customerType)
                    ) ||
                    (
                        this.props.services &&
                        this.props.services.length === 2 &&
                        (
                            this.props.services.includes(serviceTypeEnum.E_DEFTER_YUKLEME) &&
                            this.props.services.includes(serviceTypeEnum.E_DEFTER_IKINCIL_KOPYA)
                        )
                    )
                    ||
                    (
                        this.showTimeStampCheckBox() &&
                        this.props.services && this.props.services.length === 2 &&
                        (this.props.services.includes(serviceTypeEnum.E_DEFTER)
                            &&
                            (this.props.services.includes(serviceTypeEnum.E_DEFTER_YUKLEME)) || (this.props.services.includes(serviceTypeEnum.E_DEFTER_IKINCIL_KOPYA))
                        )
                    )
                    ||
                    (

                        this.props.services && this.props.services.length === 3 &&
                        this.props.services.includes(serviceTypeEnum.E_DEFTER) &&
                        this.props.services.includes(serviceTypeEnum.E_DEFTER_YUKLEME) &&
                        this.props.services.includes(serviceTypeEnum.E_DEFTER_IKINCIL_KOPYA)
                    )
                    ||  (this.showTimeStampCheckBox() &&
                        this.props.services && this.props.services.includes(serviceTypeEnum.E_TICARET))
                ) &&
            <Row>
                <Label style={{ marginLeft: "-50px",fontSize: "12px"}}check>
                    <Input type="checkbox"
                           id="checkbox"
                           style={{paddingLeft:"1rem",fontSize:"12px"}}
                           checked={this.state.useTimeStamp}
                           onChange={(e)=>this.onChangeCheck(e)} />{'   '}
                    Zaman Damgası Kullanarak Sözleşme İmzala
                </Label>
            </Row>
            }
            <Row>
                <Col lg={2}/>
                <Col lg={8}>
                    {(!this.state.useTimeStamp) &&
                        <HsmCertificateInput value={this.state.selectedCertificate}
                                             onChange={(val) => this.setState({selectedCertificate: val})}
                                             disabled={this.state.loading}/>
                    }
                    {(this.state.useTimeStamp) &&
                    <Col sm={4} style={{margin:"auto"}}>
                        <NormalButton color="primary" faIcon="fa-sync-alt"  disabled={this.state.loading}
                                      onClick={() =>{this.setState({loading:true},()=>this.signWithTimeStamp())}} style={{width: "100%"}}>
                            Zaman Damgasıyla İmzala
                        </NormalButton>
                    </Col>
                    }
                </Col>
                <Col lg={2}/>
            </Row>
            <Row>
                <Col lg={2}/>
                <Col lg={8}>
                    {!this.state.loading && this.state.selectedCertificate && this.state.selectedCertificate.certificate && this.renderPin()}
                </Col>
                <Col lg={2}/>
            </Row>
            <Row>
                <Col lg={2}/>
                <Col lg={8}>
                    {this.state.loading && <div>{this.state.message.text}</div>}
                </Col>
                <Col lg={2}/>
            </Row>
            <Row>
                <Col lg={2}/>
                <Col lg={8}>
                    {this.state.loading && <Progress animated value={this.state.percentage}/>}
                </Col>
                <Col lg={2}/>
            </Row>

        </Container>
    }
}

export default SingleFileSigner;
